import { render, staticRenderFns } from "./GyaanJyoti.vue?vue&type=template&id=48b8c263"
import script from "./GyaanJyoti.vue?vue&type=script&lang=js"
export * from "./GyaanJyoti.vue?vue&type=script&lang=js"
import style0 from "./GyaanJyoti.vue?vue&type=style&index=0&id=48b8c263&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports